import numeral from 'numeral';
import _, {isEmpty} from "lodash";

class FeeSchedule {
  constructor(data) {
    this.ranges = [];
    this.fees = [];

    let _this = this;

    // data.ranges.sort(function(a, b) {
    //   if (a.upper_bound == null && b.upper_bound != null) {
    //     return 1;
    //   }
    //   if (a.upper_bound != null && b.upper_bound == null) {
    //     return -1;
    //   }
    //   if (a.upper_bound == null && b.upper_bound == null) {
    //     return 0;
    //   }
    //   return a.upper_bound - b.upper_bound;
    // });

    data.ranges.forEach(function(item, index, array) {
      _this.addRangeFee(new RangeFee(item));
    });


    data.fees.forEach(function(item, index, array) {
      _this.addFee(new Fee(item));
    });
  }

  getRangeFee(uuid) {
    return this.ranges.find(function(item, index, array) {
      return item.uuid == uuid;
    });
  }

  addRangeFee(rangeFee) {
    let ix = this.ranges.findIndex(function(item, index, array) {
      if (rangeFee.upper_bound === null) return false;
      if (item.upper_bound === null) return true;

      return rangeFee.upper_bound < item.upper_bound;
    });

    rangeFee.fee_schedule = this;

    let last = null;
    if (this.ranges.length) {
      last = this.ranges.pop();
      if (rangeFee.upper_bound !== null || (rangeFee.upper_bound === null && last.upper_bound !== null)) {
        this.ranges.push(last);
      }
    }

    if (ix === -1) {
      this.ranges.push(rangeFee);
      ix = 0;
    }
    else {
      this.ranges.splice(ix, 0, rangeFee);
    }

    if (this.ranges.length) {
      if ((last === null || last.upper_bound !== null) && rangeFee.upper_bound !== null) {
        let andAbove = new RangeFee({ upper_bound: null, type: '$' });
        this.addRangeFee(new RangeFee(andAbove));
      }
    }

    return ix;
  }

  removeRangeFee(uuid) {
    let ix = this.ranges.findIndex(function(item, index, array) {
      return item.uuid == uuid;
    });

    if (ix !== -1) {
      let rangeFee = this.ranges[ix];
      delete rangeFee.fee_schedule;

      this.ranges.splice(ix, 1);
    }
  }

  addFee(fee) {
    this.fees.push(fee);
    return this.fees.length - 1;
  }

  removeFee(uuid) {
    let ix = this.fees.findIndex(function(item, index, array) {
      return item.uuid == uuid;
    });

    if (ix !== -1) {
      this.fees.splice(ix, 1);
    }
  }
}

class RangeFee {
  constructor(data) {
    if (data === undefined) data = {};

    this.original = {};
    this.is_new = !!data.is_new;

    this.uuid = this.original.uuid = data.uuid || uuid.v4();
    this.type = this.original.type = data.type;
    this.upper_bound = this.original.upper_bound = data.upper_bound;
    this.fee = this.original.fee = data.fee;
    this.adjuster_fee_base = this.original.adjuster_fee_base = data.adjuster_fee_base;
    this.adjuster_type = this.original.adjuster_type = data.adjuster_type || null;
    this.adjuster_fee = this.original.adjuster_fee = data.adjuster_fee || null;
    this.minimum = this.original.minimum = isNaN(data.minimum) ? null : data.minimum;
    this.adjuster_fee_base_minimum = this.original.adjuster_fee_base_minimum = isNaN(data.adjuster_fee_base_minimum) ? null : data.adjuster_fee_base_minimum;
    if (this.adjuster_fee === null) {
      this.adjuster_type = this.original.adjuster_type = null;
    }
  }

  lower_bound() {
    let lower_bound = 0.01;

    if (this.fee_schedule && this.fee_schedule.ranges.length) {
      let ix = this.fee_schedule.ranges.indexOf(this);
      if (ix !== -1 && ix  > 0) {
        let prev = this.fee_schedule.ranges[ix - 1];
        lower_bound = prev.upper_bound + 0.01;
      }
    }

    return lower_bound;
  }

  isDirty(data) {
    let dirty = false;

    data.upper_bound = _.isString(data.upper_bound) && _.isEmpty(data.upper_bound) ? null : parseFloat(data.upper_bound);
    data.fee = parseFloat(data.fee);
    data.adjuster_fee = parseFloat(data.adjuster_fee);
    data.adjuster_type = _.isString(data.adjuster_type) && _.isEmpty(data.adjuster_type) ? null : _.trim(data.adjuster_type);
    data.minimum = parseFloat(data.minimum);

    data.adjuster_fee = isNaN(data.adjuster_fee) ? null : data.adjuster_fee;
    data.minimum = isNaN(data.minimum) ? null : data.minimum;

    for (const prop in data) {
      if (data[prop] != this.original[prop]) {
        if (prop === 'minimum' && data.type !== '%') continue;
        dirty = true;
        break;
      }
    }

    return dirty;
  }
}

class Fee {
  constructor(data) {
    if (data === undefined) data = {};

    this.original = {};
    this.is_new = !!data.is_new;

    this.uuid = this.original.uuid = data.uuid || uuid.v4();
    this.name = this.original.name = data.name || '';
    this.type = this.original.type = data.type || 'fixed';
    this.rate = this.original.rate = data.rate;
    this.adjuster_rate = this.original.adjuster_rate = data.adjuster_rate;
    this.included = this.original.included = data.included || 0;
    this.taxable = this.original.taxable = data.taxable || false;
    this.discountable = this.original.discountable = data.discountable || false;
    this.default = this.original.default = data.default || false;
    this.autobill = this.original.autobill = data.autobill || false;
    this.adjuster_payout = data.adjuster_payout || {type: 'default'};
    this.original['adjuster_payout.type'] = this.adjuster_payout.type;
    this.original['adjuster_payout.rate'] = this.adjuster_payout.rate;
  }

  isDirty(data) {
    let dirty = false;

    data.rate = parseFloat(data.rate);
    data.adjuster_rate = parseFloat(data.adjuster_rate);
    data.included = parseFloat(data.included);
    data.taxable = !!parseInt(data.taxable);
    data.discountable = !!parseInt(data.discountable);
    data.default = !!parseInt(data.default);
    data['adjuster_payout.rate'] = parseFloat(data['adjuster_payout.rate']);

    for (const prop in data) {
      if (data[prop] != this.original[prop]) {
        if (prop === 'adjuster_payout.rate' && data['adjuster_payout.type'] !== 'custom') continue;
        dirty = true;
        break;
      }
    }

    return dirty;
  }

  summary() {
    let summary = '';
    summary += 'Rate: ' + numeral(this.rate).format('$0,0.[000]');

    if (this.adjuster_rate) {
      summary += '/' + numeral(this.adjuster_rate).format('$0,0.[000]');
    }

    if (this.type == 'per_unit') {
      summary += '/unit';
      if (this.included) {
        summary += '; Included: ' + this.included;
      }
    }

    if (this.discountable) {
      summary += '; Discountable';
    }

    summary += '; Adjuster\'s share: ';
    if (this.adjuster_payout.type === 'none') {
      summary += '0%';
    }
    else if (this.adjuster_payout.type === 'all') {
      summary += '100%';
    }
    else if (this.adjuster_payout.type === 'default') {
      summary += 'default';
    }
    else if (this.adjuster_payout.type === 'custom') {
      summary += '$' + this.adjuster_payout.rate;
      if (this.type === 'per_unit') {
        summary += '/unit';
      }
    }

    return summary;
  }
}

export {Fee, RangeFee, FeeSchedule};
